var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M806.693 157.834l-292.413 292.601-293.685-293.685c-16.279-16.279-42.708-16.279-58.988 0s-16.279 42.708 0 58.988l293.481 293.481-297.299 296.985c-0.032 0.032-0.063 0.063-0.095 0.095-16.247 16.247-16.31 42.553-0.079 58.91 16.185 16.372 42.615 16.435 58.972 0.205l297.503-297.189 294.188 294.188c16.31 16.31 42.708 16.279 58.988 0s16.31-42.678 0-58.988l-294-294 292.177-292.365c0.063-0.063 0.095-0.095 0.11-0.11 16.247-16.247 16.31-42.553 0.079-58.91s-42.631-16.388-58.942-0.205z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.738a6f91.svg";
export { ForwardRef as ReactComponent };